export enum PropertyGroup {
  System = 'system',
  Custom = 'custom',
}

/**
 * @deprecated
 */
export type Property = {
  id: number
  type: PropertyFieldType
  name: string
  group: PropertyGroup
	options: Array<any>
  automatic?: boolean
}

/****/
export enum PropertyFieldType {
	Date = 'Date',
	Time = 'Time',
	DateTime = 'DateTime',
	Number = 'Number',
	Double = 'Double',
  String = 'String',
	Flag = 'Flag',
	Phone = 'Phone',
	Email = 'Email',
  Files = 'Files',
  URL = 'URL'
}

export type BotProperty = {
  id?: number
  type: PropertyFieldType
  name?: string
  path?: string
  options?: Array<any> | null
  parent?: number | null
  extension?: number | null
  automatic?: boolean
  properties: Array<BotProperty>
  extensions?: Array<Omit<BotProperty, 'id' | 'options' | 'name'>>
  readOnly?: boolean
}

export type GroupedBotProperty = BotProperty & {
  group: PropertyGroup
}
/****/

export enum TabsExtraButtons {
	Csv = 'csv',
	Reset = 'reset',
	Save = 'save',
}
